<script>
  import { version } from "../utils/utils";
</script>

<footer class="">
  <p class="text-center text-xs text-gray-400 font-semibold mt-4">
    Domus Cordis &copy; 2023 - {version}
  </p>
</footer>
